import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail } from 'lucide-react';
import './ContactSection.css';

const ContactSection = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setTimeout(() => {
      setFormSubmitted(false);
      setFormData({ name: '', email: '', message: '' });
    }, 3000);
  };

  const formVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, staggerChildren: 0.2 } },
  };

  const inputVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-split">
          {/* Left Side: Contact Info */}
          <motion.div
            className="contact-info"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="contact-title">Let’s Move Together</h2>
            <p className="contact-subtitle">
              Contact us for freight transport, logistics solutions, or delivery quotes.
            </p>
            <div className="contact-details">
              <motion.div className="contact-item" whileHover={{ x: 5 }}>
                <Phone className="contact-icon" size={24} />
                <div>
                  <span className="contact-label">Call Us</span>
                  <a href="tel:+447304244779">07304 244779</a>
                </div>
              </motion.div>
              <motion.div className="contact-item" whileHover={{ x: 5 }}>
                <Mail className="contact-icon" size={24} />
                <div>
                  <span className="contact-label">Email Us</span>
                  <a href="mailto:jinalchaudhary642@gmail.com">jinalchaudhary642@gmail.com</a>
                </div>
              </motion.div>
              <motion.div className="contact-item" whileHover={{ x: 5 }}>
                <MapPin className="contact-icon" size={24} />
                <div>
                  <span className="contact-label">Visit Us</span>
                  <span>12 Waghorn Road, London, E13 9JQ</span>
                </div>
              </motion.div>
            </div>
            <div className="contact-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.2318440421495!2d0.03339191579789347!3d51.52801817963964!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a5e5e6e8f5d5%3A0x5e5e5e5e5e5e5e5e!2s12%20Waghorn%20Rd%2C%20London%20E13%209JQ%2C%20UK!5e0!3m2!1sen!2suk!4v1698765432100!5m2!1sen!2suk"
                width="100%"
                height="200"
                style={{ border: 0, borderRadius: '8px' }}
                allowFullScreen=""
                loading="lazy"
                title="CVJ Services Ltd Location"
              ></iframe>
            </div>
          </motion.div>

          {/* Right Side: Contact Form */}
          <motion.div
            className="contact-form-wrapper"
            initial="hidden"
            whileInView="visible"
            variants={formVariants}
            viewport={{ once: true }}
          >
            <h3 className="form-title">Send Us a Message</h3>
            <form className="contact-form" onSubmit={handleSubmit}>
              <motion.div className="form-group" variants={inputVariants}>
                <label htmlFor="name" className="form-label">Name</label>
                <input
                  type="text"
                  id="name"
                  className="form-input"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </motion.div>
              <motion.div className="form-group" variants={inputVariants}>
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  id="email"
                  className="form-input"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </motion.div>
              <motion.div className="form-group" variants={inputVariants}>
                <label htmlFor="message" className="form-label">Message</label>
                <textarea
                  id="message"
                  className="form-input form-textarea"
                  placeholder="Tell us about your freight needs..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </motion.div>
              <motion.button
                type="submit"
                className="contact-btn"
                whileHover={{ scale: 1.05, backgroundColor: '#FF007A' }}
                whileTap={{ scale: 0.95 }}
              >
                Submit Enquiry
              </motion.button>
              {formSubmitted && (
                <motion.p
                  className="form-success"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  Message sent! We’ll get back to you soon.
                </motion.p>
              )}
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;